import "../../components/autocomplete/AutocompletePhoneNumber.css";

import {
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  Icon,
  List,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { Col, Row, Select } from "antd";
import { LIST_CHAT_AGENT_STATUS, LIST_CHAT_CHANNEL } from "constant";
import moment from "moment";
import AgentButton from "pages/monitor/AgentButton";
import TabChatChannel from "pages/monitor/TabChatChannel";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import datetimeHelper from "../../helper/datetime-helper";
import { mapActionsToProps as agent } from "../../redux/agent";
import { mapActionsToProps as ExtensionAction } from "../../redux/cloudPBX/extension";
import { mapActionsToProps as NumberAction } from "../../redux/cloudPBX/phoneNumber";
import { mapActionsToProps as agentAction } from "../../redux/contactCenter/agentStatus";
import { mapActionsToProps as dashboardAction } from "../../redux/dashboard";
import { mapActionsToProps } from "../../redux/miniCrm/monitor";

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  button: {
    width: "100%",
    padding: 5,
  },
});

class Monitor extends React.Component {
  state = {
    value: 1,
    nameButton: "",
    isMobile: true,
    number: null,
    isListnumber: false,
    contactCode: null,
    contactCenter: null,
    chatChannel: null,
    sourcePage: null,
    isShowTotalNumber: false,
    chatAgentsId: null,
  };
  onWindowResize = () => {
    this.setState({ isMobile: window.innerWidth <= 1447 });
  };
  async componentDidMount() {
    await this.props.getListAgentStatus();
    this.props.getListPhoneNumber();
    this.props.dashboardContact();
    this.props.getStatusAgent();
    this.props.campaignsRealtime();
    this.props.getListExtension("createdAt DESC", 999, null, null, null, {
      fields: {
        id: true,
        name: true,
        username: true,
        ip: true,
        type: true,
        userAgent: true,
        status: true,
      },
    });
    this.props.agentCallsRealtime();
    this.props.getChatAgents({
      ...(this.state.chatAgentsId && { status: this.state.chatAgentsId }),
      ...(this.state.contactCenter && {
        idDepartment: this.state.contactCenter.cityCode,
        subOrgs: this.state.contactCenter.subOrgs,
      }),
    });
    this.intervalCampaign = setInterval(() => {
      return this.props.campaignsRealtime();
    }, 30000);
    this.intervalAgentCalls = setInterval(() => {
      return this.props.callsRealtime({
        number: this.state.number,
      });
    }, 1000);
    this.intervalAgentCalls = setInterval(() => {
      return this.props.agentCallsRealtime(
        null,
        null,
        this.state.contactCenter?.subOrgs || null
      );
    }, 5000);
    this.intervaExtension = setInterval(() => {
      return this.props.getListExtension(
        "createdAt DESC",
        999,
        null,
        null,
        { include: ["pbx"] },
        {
          fields: {
            id: true,
            name: true,
            username: true,
            ip: true,
            type: true,
            userAgent: true,
            status: true,
          },
        }
      );
    }, 10000);
    this.intervalDeparmentReport = setInterval(() => {
      this.props.getAgentChatReport(
        this.state.contactCenter !== null
          ? {
              idDepartment: this.state.contactCenter.idDepartment,
              subOrgs: this.state.contactCenter.subOrgs,
            }
          : {
              idDepartment: this.props.contacts?.map(
                (item) => item.idDepartment
              ),
              subOrgs: this.props.contacts?.map((item) => item.subOrgs).flat(),
            }
      );
      this.props.getChatAgents({
        ...(this.state.chatAgentsId && { status: this.state.chatAgentsId }),
        ...(this.state.contactCenter && {
          idDepartment: this.state.contactCenter.cityCode,
          subOrgs: this.state.contactCenter.subOrgs,
        }),
      });
    }, 5000);
    window.addEventListener("resize", this.onWindowResize);
  }

  componentWillUnmount() {
    clearInterval(this.intervalCampaign);
    clearInterval(this.intervalAgentCalls);
    clearInterval(this.intervaExtension);
    clearInterval(this.intervalDeparmentReport);
    window.removeEventListener("resize", this.onWindowResize);
  }

  handleChangeTab = (event, value) => {
    this.setState({ value });
  };

  handleSelecStatusAgent = (name) => {
    // nếu trùng với trạng thái hiện tại -> về all
    if (name === this.state.nameButton) {
      this.setState({ nameButton: "" });
      return;
    }
    this.setState({ nameButton: name, value: 1, chatAgentsId: null }, () => {
      if (name === "agents") {
        this.setState({ nameButton: "" });
      }
    });
  };

  handleClickChatAgentButton = (chatAgentsId) => {
    if (this.state.chatAgentsId === chatAgentsId) {
      this.setState({
        chatAgentsId: null,
      });
      return;
    }
    this.setState({
      chatAgentsId,
      nameButton: "",
      value: 4,
    });
  };

  handleChangeSelectHead = (name, value) => {
    if (name === "contactCode") {
      this.props.getListPhoneNumber(null, null, null, null, value);
      this.setState({
        number: null,
        isListnumber: true,
        contactCenter: value
          ? this.props.contacts?.find((item) => item.code === value)
          : null,
      });
      this.setState({ number: null, isShowTotalNumber: false });
      if (!value) {
        this.setState({ number: null, isShowTotalNumber: true });
      }
    }
    this.setState({ [name]: value }, () => {
      // this.itemInit();
    });
  };

  renderAgent = () => {
    const { nameButton } = this.state;
    const { agentCalls, classes, agentStatus, calls } = this.props;
    let showItem = this.state.isMobile ? 3 : 2;
    return (
      <React.Fragment>
        {agentCalls[nameButton == "" ? "agents" : nameButton] != undefined
          ? agentCalls[nameButton == "" ? "agents" : nameButton].map((n) => {
              const start = moment(
                moment(n?.lastAgentLog?.createdAt).format(
                  "YYYY-MM-DD HH:mm:ss"
                ),
                "YYYY-MM-DD HH:mm:ss"
              );
              const end = moment(
                moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                "YYYY-MM-DD HH:mm:ss"
              );
              const duration = moment.duration(end.diff(start));
              if (n.from) {
                n.statusAgent.color = "#0074d9";
              }
              return (
                <Grid item md={showItem} style={{ padding: 5 }}>
                  <Card
                    className={classes.card}
                    style={{
                      border: `3px solid ${
                        !!n.statusAgent && n.statusAgent !== undefined
                          ? n.statusAgent.color
                          : ""
                      }`,
                      height: "auto",
                      padding: "10px 0 0 15px",
                    }}>
                    <Typography
                      component="p"
                      style={{
                        fontWeight: "bold",
                        alignItems: "center",
                        display: "flex",
                      }}>
                      <Icon>person</Icon>
                      {n.user ? n.user.fullname : ""}
                    </Typography>
                    <Typography
                      component="p"
                      style={{
                        alignItems: "center",
                        display: "flex",
                        color: `${
                          n.extensionAgent
                            ? n.extensionAgent.status === "registered"
                              ? "rgb(139, 195, 74)"
                              : "red"
                            : "#000"
                        }`,
                      }}>
                      <Icon>phone</Icon>
                      {n.extension
                        ? `${n.extension.name} - ${n.extension.username}`
                        : ""}
                    </Typography>
                    <Typography
                      component="p"
                      style={{ alignItems: "center", display: "flex" }}>
                      <Icon style={{ marginRight: 5 }}>contact_phone</Icon>
                      {n.code}{" "}
                      <Icon style={{ marginRight: 5, marginLeft: 5 }}>
                        group
                      </Icon>
                      {n.group?.name}
                    </Typography>
                    <Tooltip
                      classes={{
                        popper: classes.htmlPopper,
                        tooltip: classes.htmlTooltip,
                      }}
                      PopperProps={{
                        popperOptions: {
                          modifiers: {
                            arrow: {
                              enabled: Boolean(this.state.arrowRef),
                              element: this.state.arrowRef,
                            },
                          },
                        },
                      }}
                      title={
                        <React.Fragment>
                          {n.user ? (
                            n.user.todayLogins !== undefined &&
                            n.user.todayLogins.length != 0 ? (
                              <React.Fragment>
                                <Typography color="inherit">
                                  Chi tiết đăng nhập lần cuối
                                </Typography>
                                {n.user.todayLogins.map((item, key) => {
                                  return (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}>
                                      <Icon style={{ marginRight: 5 }}>
                                        query_builder
                                      </Icon>
                                      Lần {key + 1}:{" "}
                                      {datetimeHelper.toFormat(
                                        item,
                                        "YYYY-MM-DD HH:mm:ss"
                                      )}
                                    </div>
                                  );
                                })}
                              </React.Fragment>
                            ) : (
                              <React.Fragment />
                            )
                          ) : (
                            <React.Fragment />
                          )}
                        </React.Fragment>
                      }>
                      <Typography
                        component="p"
                        style={{ alignItems: "center", display: "flex" }}>
                        <Icon style={{ marginRight: 5 }}>restore</Icon>
                        {n.user ? (
                          n.user.todayLogins !== undefined &&
                          n.user.todayLogins.length != 0 ? (
                            <Typography component="p">
                              {datetimeHelper.toFormat(
                                n.user.todayLogins[
                                  n.user.todayLogins.length - 1
                                ],
                                "YYYY-MM-DD HH:mm:ss"
                              )}
                            </Typography>
                          ) : (
                            "N/A"
                          )
                        ) : (
                          <React.Fragment />
                        )}
                      </Typography>
                    </Tooltip>
                    <Divider style={{ marginBottom: 5, marginTop: 5 }} />
                    <Typography
                      component="p"
                      style={{ alignItems: "center", display: "flex" }}>
                      Số điện thoại:{" "}
                      {n.from ? (
                        <Typography
                          component="p"
                          variant="title"
                          style={{ color: "red", marginLeft: 5 }}>
                          {n.from}
                        </Typography>
                      ) : (
                        "N/A"
                      )}
                    </Typography>
                    <Typography component="p">
                      Thời gian:{" "}
                      {n.bridgedDuration
                        ? datetimeHelper.secondToHHMMSS(n.bridgedDuration)
                        : "N/A"}
                    </Typography>
                    <Typography component="p">
                      Trạng thái: {n.statusCall ? n.statusCall : "N/A"}
                    </Typography>
                    <Typography component="p">
                      Loại: {n.type ? n.type : "N/A"}
                    </Typography>
                    <Typography component="p">
                      Thời gian nghỉ:{" "}
                      {n?.lastAgentLog?.createdAt &&
                      n.statusId &&
                      (n.statusId === "pause" || n.statusId === "eating")
                        ? duration.hours() +
                          ":" +
                          duration.minutes() +
                          ":" +
                          duration.seconds()
                        : ""}
                    </Typography>
                    {
                      <React.Fragment>
                        <Divider style={{ marginBottom: 5, marginTop: 5 }} />
                        <Grid
                          container
                          style={{
                            marginTop: 15,
                            marginBottom: "10px",
                            textAlign: "center",
                          }}>
                          <Grid item md={6}>
                            <Button
                              disabled={
                                n.statusCall == "answering" ? false : true
                              }
                              variant="contained"
                              size="small"
                              style={{
                                backgroundColor:
                                  n.statusCall == "answering" ? "#8bc34a" : "",
                                color: "#fff",
                                whiteSpace: "nowrap",
                              }}
                              onClick={() =>
                                this.props.spyCall(
                                  n.cdrId,
                                  "spy",
                                  agentStatus ? agentStatus.extensionId : ""
                                )
                              }>
                              Nghe hỗ trợ
                            </Button>
                          </Grid>
                          <Grid item md={6}>
                            <Button
                              disabled={
                                n.statusCall == "answering" ? false : true
                              }
                              variant="contained"
                              size="small"
                              style={{
                                backgroundColor:
                                  n.statusCall == "answering" ? "#55bfe0" : "",
                                color: "#fff",
                                whiteSpace: "nowrap",
                              }}
                              onClick={() =>
                                this.props.spyCall(
                                  n.cdrId,
                                  "whisper",
                                  agentStatus ? agentStatus.extensionId : ""
                                )
                              }>
                              Nghe xen
                            </Button>
                          </Grid>
                        </Grid>
                      </React.Fragment>
                    }
                  </Card>
                </Grid>
              );
            })
          : null}
      </React.Fragment>
    );
  };

  render() {
    let {
      classes,
      agentCalls,
      listExtension,
      calls,
      contacts,
      listPhoneNumber,
      agentChatReport,
    } = this.props;
    const { isShowTotalNumber } = this.state;
    listPhoneNumber = isShowTotalNumber ? [] : listPhoneNumber;

    const { isListnumber } = this.state;

    const listExtensionResult =
      typeof listExtension === "object"
        ? Object.keys(listExtension).map((key) => listExtension[key])
        : listExtension;
    const { value } = this.state;

    const listPhoneNumberResult = isListnumber
      ? typeof listPhoneNumber === "object"
        ? Object.keys(listPhoneNumber).map((key) => listPhoneNumber[key])
        : listPhoneNumber
      : [];

    return (
      <React.Fragment>
        <Paper square style={{ padding: "0 5px 5px 10px" }}>
          <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
            <Col xs={{ span: 12 }} lg={{ span: 8 }} xxl={{ span: 6 }}>
              <div className="antd-custom-select-container">
                <span className="antd-custom-select-label">Contact Center</span>
                <Select
                  showSearch
                  placeholder="Tất cả"
                  optionFilterProp="children"
                  value={this.state.contactCode}
                  className="antd-custom-select"
                  popupClassName="antd-custom-select-dropdown"
                  onChange={this.handleChangeSelectHead.bind(
                    this,
                    "contactCode"
                  )}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  suffixIcon={<i className="fas fa-chevron-down"></i>}
                  options={[
                    { value: null, label: "Tất cả" },
                    ...(contacts || []).map((d) => ({
                      value: d.code,
                      label: d.name,
                    })),
                  ]}
                />
              </div>
            </Col>
            <Col xs={{ span: 12 }} lg={{ span: 5 }} xxl={{ span: 6 }}>
              <div className="antd-custom-select-container">
                <span className="antd-custom-select-label">Kênh call</span>
                <Select
                  showSearch
                  placeholder="Tất cả"
                  optionFilterProp="children"
                  value={this.state.number}
                  className="antd-custom-select"
                  popupClassName="antd-custom-select-dropdown"
                  suffixIcon={<i className="fas fa-chevron-down"></i>}
                  onChange={this.handleChangeSelectHead.bind(this, "number")}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    { value: null, label: "Tất cả" },
                    ...(listPhoneNumberResult || []).map((d) => ({
                      value: d.id,
                      label: d.id,
                    })),
                  ]}
                />
              </div>
            </Col>
            <Col xs={{ span: 12 }} lg={{ span: 5 }} xxl={{ span: 6 }}>
              <div className="antd-custom-select-container">
                <span className="antd-custom-select-label">Kênh chat</span>
                <Select
                  showSearch
                  placeholder="Đang phát triển"
                  optionFilterProp="children"
                  value={this.state.chatChannel}
                  className="antd-custom-select"
                  popupClassName="antd-custom-select-dropdown"
                  suffixIcon={<i className="fas fa-chevron-down"></i>}
                  onChange={this.handleChangeSelectHead.bind(
                    this,
                    "chatChannel"
                  )}
                  options={[{ id: null, name: "Đang phát triển" }]
                    .concat(LIST_CHAT_CHANNEL)
                    .map((item) => ({
                      value: item.id,
                      label: item.name,
                    }))}
                />
              </div>
            </Col>
            <Col xs={{ span: 12 }} lg={{ span: 6 }} xxl={{ span: 6 }}>
              <div className="antd-custom-select-container">
                <span className="antd-custom-select-label">Nguồn trang</span>
                <Select
                  showSearch
                  placeholder="Đang phát triển"
                  optionFilterProp="children"
                  value={this.state.sourcePage}
                  className="antd-custom-select"
                  popupClassName="antd-custom-select-dropdown"
                  suffixIcon={<i className="fas fa-chevron-down"></i>}
                  onChange={this.handleChangeSelectHead.bind(
                    this,
                    "sourcePage"
                  )}
                  options={[{ id: null, name: "Đang phát triển" }]
                    .concat([])
                    .map((item) => ({
                      value: item.id,
                      label: item.name,
                    }))}
                />
              </div>
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
            <Col xs={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <AgentButton
                variant="online"
                title="Trực tuyến"
                value={
                  (agentCalls?.agentAvailable?.length || 0) +
                  (agentChatReport?.agentOnline || 0)
                }
                disabled
              />
            </Col>
            <Col xs={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <AgentButton
                variant="ready"
                title="Sẵn sàng"
                value={
                  (agentCalls?.agentReady?.length || 0) +
                  (agentChatReport?.agentReadyChat || 0)
                }
                disabled
              />
            </Col>
            <Col xs={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <AgentButton
                variant="working"
                title="Đang làm việc"
                value={
                  (agentCalls?.agentCallInbound?.length || 0) +
                  (agentChatReport?.agentChatting || 0)
                }
                disabled
              />
            </Col>
            <Col xs={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <AgentButton
                variant="busy"
                title="Bận"
                value={agentChatReport?.agentBusy || 0}
                disabled
              />
            </Col>
            <Col xs={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <AgentButton
                variant="pause"
                title="Tạm nghỉ"
                value={
                  (agentCalls?.pause?.length || 0) +
                  (agentChatReport?.agentPause || 0)
                }
                disabled
              />
            </Col>
            <Col xs={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <AgentButton
                variant="eating"
                title="Ăn ca"
                value={
                  (agentCalls?.eating?.length || 0) +
                  (agentChatReport?.agentEatting || 0)
                }
                disabled
              />
            </Col>
          </Row>

          <Grid container spacing={24}>
            <Grid item md={6}>
              <Card className={classes.card}>
                <CardContent>
                  <Typography
                    variant="title"
                    gutterBottom
                    onClick={() => this.setState({ value: 2 })}>
                    Call Inbounds: {calls.inboundCalls?.length || 0}
                  </Typography>
                  <Divider style={{ marginBottom: 5 }} />
                  <Row gutter={[8, 8]}>
                    {[
                      {
                        id: "agentAvailable",
                        variant: "online",
                        title: "Trực tuyến",
                      },
                      {
                        id: "agentReady",
                        variant: "ready",
                        title: "Sẵn sàng",
                      },
                      {
                        id: "agentCallInbound",
                        variant: "working",
                        title: "Đang nhận cuộc gọi",
                      },
                      { id: null },
                      {
                        id: "pause",
                        variant: "pause",
                        title: "Tạm nghỉ",
                      },
                      {
                        id: "eating",
                        variant: "eating",
                        title: "Ăn ca",
                      },
                    ].map((item) => (
                      <Col xs={{ span: 12 }} lg={{ span: 8 }} key={item.id}>
                        {item.id !== null && (
                          <AgentButton
                            variant={item.variant}
                            title={item.title}
                            value={agentCalls[item.id]?.length || 0}
                            onClick={() => this.handleSelecStatusAgent(item.id)}
                            blur={
                              (this.state.nameButton !== item.id &&
                                this.state.nameButton !== "") ||
                              this.state.chatAgentsId
                            }
                            active={this.state.nameButton === item.id}
                          />
                        )}
                      </Col>
                    ))}
                  </Row>
                </CardContent>
              </Card>
            </Grid>

            <Grid item md={6}>
              <Card className={classes.card}>
                <CardContent>
                  <Typography variant="title" gutterBottom>
                    Kênh chat vào: {agentChatReport?.agentOnline}
                  </Typography>
                  <Divider style={{ marginBottom: 5 }} />
                  <Row gutter={[8, 8]}>
                    {LIST_CHAT_AGENT_STATUS.map((item) => (
                      <Col xs={{ span: 12 }} lg={{ span: 8 }} key={item.id}>
                        <AgentButton
                          variant={item.variant}
                          title={item.title}
                          value={agentChatReport?.[item.id] || 0}
                          onClick={() =>
                            this.handleClickChatAgentButton(item.chatAgentsId)
                          }
                          blur={
                            this.state.nameButton ||
                            (this.state.chatAgentsId &&
                              this.state.chatAgentsId !== item.chatAgentsId)
                          }
                          active={this.state.chatAgentsId === item.chatAgentsId}
                        />
                      </Col>
                    ))}
                  </Row>
                </CardContent>
              </Card>
            </Grid>

            <Grid item md={6}>
              <Card className={classes.card}>
                <CardContent>
                  <Typography
                    variant="title"
                    gutterBottom
                    onClick={() => this.setState({ value: 3 })}>
                    Call Outbounds: {calls.outboundCalls?.length || 0}
                  </Typography>
                  <Divider style={{ marginBottom: 5 }} />

                  <Row gutter={[8, 8]}>
                    {[
                      {
                        id: "manual",
                        variant: "online",
                        title: "Trực tuyến",
                      },
                      {
                        id: "agentOuboundAvail",
                        variant: "ready",
                        title: "Sẵn sàng",
                      },
                      {
                        id: "agentCallOutbound",
                        variant: "working",
                        title: "Đang gọi ra",
                      },
                    ].map((item) => (
                      <Col xs={{ span: 12 }} lg={{ span: 8 }} key={item.id}>
                        <AgentButton
                          variant={item.variant}
                          title={item.title}
                          value={agentChatReport?.[item.id] || 0}
                          onClick={() => this.handleSelecStatusAgent(item.id)}
                          blur={
                            (this.state.nameButton !== item.id &&
                              this.state.nameButton !== "") ||
                            this.state.chatAgentsId
                          }
                          active={this.state.nameButton === item.id}
                        />
                      </Col>
                    ))}
                  </Row>

                  <Typography
                    style={{ marginTop: "5px", color: "#a128a1" }}
                    variant="caption"
                    component="span">
                    *Số Agent call ở trạng thái tạm nghỉ, ăn ca không phân biệt
                    Inbound hay Outbound
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Card
            className={classes.card}
            onClick={() => this.setState({ value: 0 })}
            style={{ marginTop: "12px" }}>
            <CardContent>
              <Typography variant="title" gutterBottom>
                Extensions:{" "}
                {listExtensionResult ? listExtensionResult.length : 0}
              </Typography>
              <Divider style={{ marginBottom: 10 }} />
              <Grid container>
                <Grid item md={6}>
                  <Typography
                    component="p"
                    style={{ color: "rgb(139, 195, 74)" }}>
                    Online:{" "}
                    {listExtensionResult
                      ? listExtensionResult.filter(
                          (item) => item.status === "registered"
                        ).length
                      : 0}
                  </Typography>
                </Grid>
                <Grid item md={6}>
                  <Typography component="p" style={{ color: "red" }}>
                    Offline:{" "}
                    {listExtensionResult
                      ? listExtensionResult.filter(
                          (item) => item.status === "unregistered"
                        ).length
                      : 0}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Paper>
        <Paper square style={{ marginBottom: 10 }}>
          <Tabs
            value={this.state.value}
            indicatorColor="primary"
            textColor="primary"
            onChange={this.handleChangeTab}>
            <Tab label="Máy lẻ" />
            <Tab label="Điện thoại viên" />
            <Tab label="Inbound" />
            <Tab label="Outbound" />
            <Tab label="Kênh chat" />
          </Tabs>
          {value === 0 && (
            <React.Fragment>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow
                    style={{ borderTop: "1px solid rgba(224, 224, 224, 1)" }}>
                    <TableCell>Tên máy lẻ</TableCell>
                    <TableCell>Tài khoản</TableCell>
                    {/* <TableCell>Ip</TableCell> */}
                    <TableCell>Loại</TableCell>
                    <TableCell>Trạng thái</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listExtensionResult
                    ? listExtensionResult.map((item, key) => {
                        if (key < listExtensionResult.length - 1)
                          return (
                            <TableRow key={key}>
                              <TableCell>{item.name}</TableCell>
                              <TableCell>{item.username}</TableCell>
                              {/* <TableCell>{item.type == 'sip' ? item.pbx ? item.pbx.externalIp : '' : ''}</TableCell> */}
                              <TableCell>{item.type}</TableCell>
                              <TableCell>
                                {item.status == "registered" ? (
                                  <Typography
                                    className={classes.secondaryHeading}
                                    style={{ color: "rgb(139, 195, 74)" }}>
                                    Online
                                  </Typography>
                                ) : (
                                  <Typography
                                    className={classes.secondaryHeading}
                                    style={{ color: "red" }}>
                                    {" "}
                                    Offline
                                  </Typography>
                                )}
                              </TableCell>
                            </TableRow>
                          );
                      })
                    : null}
                </TableBody>
              </Table>
            </React.Fragment>
          )}
          {value === 1 && (
            <React.Fragment>
              <List className={classes.root}>
                <Grid container>{this.renderAgent()}</Grid>
              </List>
            </React.Fragment>
          )}
          {value === 2 && (
            <Table className={classes.table}>
              <TableHead>
                <TableRow
                  style={{ borderTop: "1px solid rgba(224, 224, 224, 1)" }}>
                  <TableCell>Số điện thoại</TableCell>
                  <TableCell>Đầu số</TableCell>
                  <TableCell>Mã điện thoại viên</TableCell>
                  <TableCell>Hàng đợi</TableCell>
                  <TableCell>Máy lẻ</TableCell>
                  <TableCell>Trạng thái</TableCell>
                  <TableCell>Thời lượng</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {calls.inboundCalls !== undefined
                  ? calls.inboundCalls.map((item, key) => {
                      return (
                        <TableRow key={key}>
                          <TableCell>{item.from}</TableCell>
                          <TableCell>{item.to}</TableCell>
                          <TableCell>
                            {item.agent ? item.agent.code : ""}
                          </TableCell>
                          <TableCell>
                            {item.queue ? item.queue.name : ""}
                          </TableCell>
                          <TableCell>{item.extension.name}</TableCell>
                          <TableCell>{item.status}</TableCell>
                          <TableCell>
                            {datetimeHelper.secondToHHMMSS(
                              item.bridgedDuration
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  : null}
              </TableBody>
            </Table>
          )}
          {value === 3 && (
            <Table className={classes.table}>
              <TableHead>
                <TableRow
                  style={{ borderTop: "1px solid rgba(224, 224, 224, 1)" }}>
                  {/* <TableCell>Chiến dịch</TableCell>
                                <TableCell>Điện thoại viên</TableCell> */}
                  <TableCell>Đầu số</TableCell>
                  <TableCell>Số điện thoại</TableCell>
                  <TableCell>Máy lẻ</TableCell>
                  <TableCell>Trạng thái</TableCell>
                  <TableCell>Thời lượng</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {calls.outboundCalls != undefined
                  ? calls.outboundCalls.map((item, key) => {
                      return (
                        <TableRow key={key}>
                          {/* <TableCell>{!!item.campaign ? item.campaign.name : ''}</TableCell>
                                                    <TableCell>{!!item.agent ? item.agent.code : ''}</TableCell> */}
                          <TableCell>{item.from}</TableCell>
                          <TableCell>{item.to}</TableCell>
                          <TableCell>{item.extension.name}</TableCell>
                          <TableCell>{item.status}</TableCell>
                          <TableCell>
                            {datetimeHelper.secondToHHMMSS(
                              item.bridgedDuration
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  : null}
              </TableBody>
            </Table>
          )}
          {value === 4 && <TabChatChannel />}
        </Paper>
      </React.Fragment>
    );
  }
}

Monitor.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  monitor: state.monitor.monitor,
  campaigns: state.monitor.campaigns,
  agentCalls: state.monitor.agentCalls,
  calls: state.monitor.calls,
  listStatus: state.agentStatus.agentStatus,
  agentStatus: state.agent.status,
  listExtension: state.extension.extensions,
  listPhoneNumber: state.phoneNumber.phoneNumbers,
  contacts: state.dashboard.contact,
  agentChatReport: state.dashboard.agentChatReport,
});

const Agent = connect(null, agentAction)(Monitor);
const Agent2 = connect(null, agent)(Agent);
const Extension = connect(null, ExtensionAction)(Agent2);
const NumberConnect = connect(null, NumberAction)(Extension);
const Dashboard = connect(null, dashboardAction)(NumberConnect);

Monitor = connect(mapStateToProps, mapActionsToProps)(Dashboard);

export default withStyles(styles)(Monitor);
